import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col overflow-hidden w-full bg-white"
}
const _hoisted_2 = { class: "flex flex-row justify-between items-center border-b border-gray-lp-400 mb-4 py-6 font-semibold text-xl mr-4 text-black-lp-200" }
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col overflow-hidden w-full bg-white"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Tabs = _resolveComponent("Tabs")!

  return (_ctx.codReconcileConsoleSubconsoleEnable)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("codReconcile.title")), 1),
        _createVNode(_component_router_view)
      ]))
    : (_openBlock(), _createBlock("div", _hoisted_3, [
        _createVNode(_component_Tabs, {
          modelValue: _ctx.activeMenu,
          onChange: _ctx.onChangeTabs,
          data: _ctx.tabs,
          rounded: false,
          titleSize: 16,
          gap: 10
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_view)
          ]),
          _: 1
        }, 8, ["modelValue", "onChange", "data"])
      ]))
}